import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../components/homePage.vue";


const routes = [

  {
    path: "/",
    name: "home",
    component: HomeView,
  },





];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    // Always scroll to top
    return { top: 0 };
  },
});

export default router;
